import { CognitoApp } from "./CognitoApp";

export default CognitoApp;